import React, {useState, useEffect, useMemo} from 'react'
import {ReactComponent as Shirt} from '../../assets/icons/shirt.svg'
import {ReactComponent as Upload} from '../../assets/icons/upload.svg'
import {ReactComponent as TextFields} from '../../assets/icons/text_fields.svg'
import {ReactComponent as Question} from '../../assets/icons/question.svg'
import {ReactComponent as ColorLens} from '../../assets/icons/color_lens.svg'
import {ReactComponent as Layers} from '../../assets/icons/all-layers.svg'
import {ReactComponent as Templates} from '../../assets/icons/templates.svg'
import {ReactComponent as Warning} from '../../assets/icons/warning.svg'
import {ReactComponent as Folder} from '../../assets/icons/folder.svg'
import MockupGuideline from './artwork-editor/MockupGuideline'
import {useSelectedVariantContext} from './context/SelectedVariantContext'
import {
    actionAddImageFromLibrary,
    actionAddTextLayer,
    actionChangeSelectedLayer,
    actionChangeTabDesign
} from './context/SelectedVariantContext/action'
import DesignLibraryModal from './artwork-editor/design-library/DesignLibraryModal'
import {useEditorLayers} from '../../hooks/useEditorLayers'
import useUploadFile from '../../hooks/useUploadFile'
import {Tooltip} from 'reactstrap'
import {ALERT_PRODUCT_CREATE, TITLE_ALERT_PRODUCT_CREATE} from '../../constant'
import {getStoreSetting} from '../../services/CurrentStoreServices'

const Toolbar = () => {
    const {
        state: {
            tabDesign,
            selectedAttribute,
            selectedSide,
            runningImageCompress,
            productCreatedType,
            libraries = {},
            cropMode,
            product,
        },
        dispatch,
    } = useSelectedVariantContext()
    const {items = []} = libraries
    const {pending} = useUploadFile()
    const layers = useEditorLayers()
    const background = selectedAttribute?.safeZone[selectedSide]
    const [isOpenImageDesign, setIsOpenImageDesign] = useState(false)
    const [openGuideline, setOpenGuideline] = useState(false)
    const toggleGuideline = () => setOpenGuideline(!openGuideline)
    const [tooltipOpen, setTooltipOpen] = useState(true)
    const [isMounted, setIsMounted] = useState(false)

    const toggle = () => setTooltipOpen(!tooltipOpen)

    const setTabDesign = (type) => {
        if (type === 'background') {
            if (background) {
                dispatch(actionChangeSelectedLayer(null))
                dispatch(actionChangeTabDesign(type))
            }
        } else {
            if (type !== 'layer') dispatch(actionChangeSelectedLayer(null))
            dispatch(actionChangeTabDesign(type))
        }
    }

    const _toggle = () => {
        setIsOpenImageDesign((prev) => !prev)
    }

    const onAddText = () => {
        if (background) {
            dispatch(actionAddTextLayer())
        }
    }

    const onAddImageFromLibrary = () => {
        if (background) {
            dispatch(actionAddImageFromLibrary())
        }
    }

    useEffect(() => {
        setIsMounted(true)
    }, [])

    const isDisableTabTemplate = useMemo(() => {
        return (
            cropMode || productCreatedType === 'regularNoTemplate'
        )
    }, [cropMode, productCreatedType, product, getStoreSetting])

    return (
        <>
            <ul>
                <li
                    className={`text-center ${pending || runningImageCompress || cropMode ? 'disabled' : ''} ${tabDesign === 'product' ? 'active' : ''}`}
                    id="tab_product_v3"
                    onClick={() => (tabDesign === 'product' ? setTabDesign('') : setTabDesign('product'))}
                >
                    <div className="Icon" id="TooltipProduct">
                        <Shirt />
                    </div>
                    <label>Product</label>
                </li>
                <div id={'design_tools'}>
                <li
                    className={`text-center ${(background && !(pending || runningImageCompress || cropMode)) ? '' : 'disabled'} ${tabDesign === 'addImage' ? 'active' : ''}`}
                    id="tab_add_image_v3"
                    onClick={() => {
                        if (background) {
                            _toggle()
                        }
                    }}
                >
                    <div className="Icon">
                        <Upload />
                    </div>
                    <label>Add image</label>
                </li>
                <li id="tab_add_text_v3" className={`text-center ${(background && !(pending || runningImageCompress || cropMode) && productCreatedType !== 'regularNoTemplate') ? '' : 'disabled'} ${tabDesign === 'addText' ? 'active' : ''}`} onClick={cropMode ? () => {} : onAddText}>
                    <div className="Icon">
                        <TextFields />
                    </div>
                    <label>Add text</label>
                </li>
                <li
                    id="tab_all_layers_v3"
                    className={`text-center  ${
                        background && !(pending || runningImageCompress || isDisableTabTemplate) ? '' : 'disabled'
                    } ${tabDesign === 'templates' ? 'active' : ''}`}
                    onClick={
                        isDisableTabTemplate
                            ? () => {}
                            : () => (tabDesign === 'templates' ? setTabDesign('') : setTabDesign('templates'))
                    }
                >
                    <div className="Icon">
                        <Templates />
                    </div>
                    <label>My template</label>
                </li>
                {items.length > 0 && (
                    <li id='tab_library'
                        className={`text-center ${(background && !(pending || runningImageCompress || cropMode)) ? '' : 'disabled'} ${tabDesign === 'tabLibrary' ? 'active' : ''}`}
                        onClick={cropMode ? () => {} : () => tabDesign === 'tabLibrary' ? setTabDesign('') : setTabDesign('tabLibrary')}>
                        <div className='Icon'>
                            <Folder />
                        </div>
                        <label>AI Library</label>
                    </li>
                )}
                <li id="tab_all_layers_v3" className={`text-center ${(layers.length === 0 || (pending || runningImageCompress || cropMode)) ? 'disabled' : ''} ${tabDesign === 'layer' ? 'active' : ''}`}
                    onClick={cropMode ? () => {} : () => tabDesign === 'layer' ? setTabDesign('') : setTabDesign('layer')}>
                    <div className='Icon'>
                        <Layers />
                    </div>
                    <label>Layers</label>
                </li>
                </div>
                <li
                    id="tab_background_color_v3"
                    className={`text-center ${(background && !(pending || runningImageCompress || cropMode) && productCreatedType !== 'regularNoTemplate') ? '' : 'disabled'} ${tabDesign === 'background' ? 'active' : ''}`}
                    onClick={cropMode ? () => {} : () => tabDesign === 'background' ? setTabDesign('') : setTabDesign('background')}
                >
                    <div className="Icon">
                        <ColorLens />
                    </div>
                    <label>Background color</label>
                </li>
                <li id="tab_guideline_v3" className={`text-center ${pending || runningImageCompress || cropMode ? 'disabled' : ''}`}
                    onClick={cropMode ? () => {} : toggleGuideline}>
                    <div className="Icon">
                        <Question />
                    </div>
                    <label>Guideline</label>
                    <MockupGuideline isOpen={openGuideline} toggle={cropMode ? () => {} : toggleGuideline} />
                </li>
            </ul>
            {isOpenImageDesign && <DesignLibraryModal isOpen={isOpenImageDesign} toggle={_toggle} />}
            {/*{(isMounted && (productCreatedType === 'regularHasTemplate' || productCreatedType === 'regularNoTemplate' || productCreatedType === 'combineLayout' || productCreatedType === 'type2D')) && (*/}
            {/*    <Tooltip*/}
            {/*        placement="left-start"*/}
            {/*        isOpen={tooltipOpen}*/}
            {/*        target="tab_product_v3"*/}
            {/*        className="custom-tooltip"*/}
            {/*    >*/}
            {/*        <div className="HeadTooltip">*/}
            {/*            <div className="Icon">*/}
            {/*                <Warning />*/}
            {/*            </div>*/}
            {/*            <label>{TITLE_ALERT_PRODUCT_CREATE[productCreatedType]}</label>*/}
            {/*            <span className="Close" onClick={toggle}>✕</span>*/}
            {/*        </div>*/}
            {/*        <div className={'BodyTooltip'}>*/}
            {/*            {ALERT_PRODUCT_CREATE[productCreatedType]}*/}
            {/*        </div>*/}
            {/*    </Tooltip>*/}
            {/*)}*/}
        </>
    )
}

export default Toolbar